<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ErrorWrapper } from '@utils/error-handler'
import { ADMIN_ROLE } from '@utils/constant'
import {
  siteListMethod,
  authComputed,
  categoryListMethod,
} from '@state/helpers'

export default {
  page: {
    title: 'Sub Category List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Table },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      lists: [],
      platformId: 'All',
      siteconfiglist: [],
      allCategoryList: [],
      fields: [
        {
          value: 'name',
          text: 'Name',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'description',
          text: 'Description',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'categoryData',
          text: 'Category Name',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'action',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        { key: 'name', label: 'Name', colType: 'default' },
        { key: 'description', label: 'Description', colType: 'default' },
        { key: 'categoryData', label: 'Category Name', colType: 'default' },
        {
          key: 'createdAt',
          label: 'Added On',
          colType: 'date',
        },
      ],
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getListOfPlatform()
    this.getListOfSubcategory()
  },
  methods: {
    ...siteListMethod,
    ...categoryListMethod,

    // Get list of all students role wise
    getListOfSubcategory() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'date',
        order: '1',
      }
      this.fetchAllSubCategoryList({ filter })
        .then((categoryList) => {
          this.isLoading = false
          this.lists = JSON.parse(JSON.stringify(categoryList))
          this.allCategoryList = JSON.parse(JSON.stringify(categoryList))
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },

    handleRoute() {
      this.$router.push({ name: 'subcategory.add' })
    },
    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          listitems.push({ value: 'All', text: 'All' })
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getPlatformCategories() {
      let listitems = []
      listitems.push({ value: 'All', text: 'All' })
      this.allCategoryList.forEach((element) => {
        if (element.platform_id === Number(this.platformId)) {
          listitems.push(element)
        }
      })
      this.lists = listitems
      if (this.platformId !== 'All') {
        let listitems = []
        this.allCategoryList.forEach((element) => {
          if (element.platform_id === Number(this.platformId)) {
            listitems.push(element)
          }
        })
        this.lists = listitems
      } else {
        this.lists = this.allCategoryList
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <button
              v-if="role === 'admin' || role === 'administrator'"
              id="show-modal"
              class="btn btn-info"
              @click="handleRoute"
              ><i class="ti-plus"></i>Add Sub Category</button
            ><br /><br />
            <b-form-group
              v-if="role === 'admin'"
              label="Select Platform"
              label-for="input-1"
            >
              <b-form-select
                v-model="platformId"
                :options="siteconfiglist"
                style="width: 50%"
                @change="getPlatformCategories"
              ></b-form-select>
            </b-form-group>
            <div class="mt-2">
              <Table
                :items="lists ? lists : []"
                :fields="fields"
                :bordered="true"
                :viewbtn="true"
                :deletebtn="true"
                :editbtn="true"
                :subcategory="true"
                :display-fields="displayFields"
              ></Table>
            </div>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.zoom-btn {
  color: white;
}
</style>
